/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authcallbackalreadyclaimed3Inputs */

const en_authcallbackalreadyclaimed3 = /** @type {(inputs: Authcallbackalreadyclaimed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This diagnostic was already used to create a case. Open it from your case list.`)
};

const pt_authcallbackalreadyclaimed3 = /** @type {(inputs: Authcallbackalreadyclaimed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este diagnóstico já foi usado para criar um caso. Abra-o a partir da lista de casos.`)
};

/**
* | output |
* | --- |
* | "This diagnostic was already used to create a case. Open it from your case list." |
*
* @param {Authcallbackalreadyclaimed3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const authcallbackalreadyclaimed3 = /** @type {((inputs?: Authcallbackalreadyclaimed3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authcallbackalreadyclaimed3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_authcallbackalreadyclaimed3(inputs)
	return pt_authcallbackalreadyclaimed3(inputs)
});
export { authcallbackalreadyclaimed3 as "authCallbackAlreadyClaimed" }